<template>
  <div class="home">
    <el-container>
      <el-header>
        <v-head
          :active="4"
          :bannerData="bannerData"
          :isBanner="true"
          :color="'black'"
          indicator="none"
        ></v-head>
        <software-img  :bannerData="bannerData"
          :isBanner="true"
          :color="'black'"
          indicator="none" />
      </el-header>
      <el-main style="position: relative;height: 100%;">
        <div class="content">
          <!-- 软件服务 -->
          <div class="service">
            <div class="wrapper">
              <div class="title">软件服务</div>
              <div class="bg-scheme-svg">
                <div style="width:1427px; margin:0 auto;">
                  <svg width="1427" height="106" viewBox="0 0 1427 106" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient id="text-stroke-gradient-1" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stop-color="#000000"/>
                        <stop offset="100%" stop-color="rgba(0,0,0,0)"/>
                      </linearGradient>
                    </defs>
                    <text
                      x="50%"
                      y="50%"
                      text-anchor="middle"
                      font-family="PingFang SC, PingFang SC-400"
                      font-weight="600"
                      stroke="url(#text-stroke-gradient-1)"
                      stroke-width="2"
                      fill="transparent"
                      opacity="0.2"
                      dominant-baseline="middle"
                      font-size="76"
                      style="font-size:76px !important;"
                    >
                      SOFTWARE SERVICE
                    </text>
                  </svg>
                </div>
              </div>
              <div class="list">
                <div v-for="(item, index) in softwareList1" :key="item.name"  class="item" @mouseenter="service1Enter(index)">
                  <div class="pic" :class="softwareListActive1 == index ? 'expandPic' : ''"><img :src="softwareListActive1 == index ? item.expandImg : item.img" alt=""></div>
                  <div class="box" :class="softwareListActive1 == index ? 'expandBox' : ''">
                    <div class="logo"><img :src="item.logo" alt=""></div>
                    <div class="en">{{item.en}}</div>
                    <div class="label">{{item.name}}</div>
                    <div class="info">{{item.info}}</div>
                  </div>
                </div>
              </div>
              <div class="list">
                <div v-for="(item, ind) in softwareList2" :key="item.name"  class="item" @mouseenter="service2Enter(ind)">
                  <div class="pic" :class="softwareListActive2 == ind ? 'expandPic' : ''"><img :src="softwareListActive2 == ind ? item.expandImg : item.img" alt=""></div>
                  <div class="box" :class="softwareListActive2 == ind ? 'expandBox' : ''">
                    <div class="logo"><img :src="item.logo" alt=""></div>
                    <div class="en">{{item.en}}</div>
                    <div class="label">{{item.name}}</div>
                    <div class="info">{{item.info}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 创新能力 -->
          <div class="ability">
            <div class="wrapper">
              <div class="title">创新能力</div>
              <div class="bg-scheme-svg">
                <div style="width:1427px; margin:0 auto;">
                  <svg width="1427" height="106" viewBox="0 0 1427 106" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient id="text-stroke-gradient-2" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stop-color="#000000"/>
                        <stop offset="100%" stop-color="rgba(0,0,0,0)"/>
                      </linearGradient>
                    </defs>
                    <text
                      x="50%"
                      y="50%"
                      text-anchor="middle"
                      font-size="76"
                      font-family="PingFang SC, PingFang SC-400"
                      font-weight="600"
                      stroke="url(#text-stroke-gradient-2)"
                      stroke-width="2"
                      fill="transparent"
                      opacity="0.1"
                      dominant-baseline="middle"
                        style="font-size:76px !important;"
                    >
                      INNOVATION ABILITY
                    </text>
                  </svg>
                </div>
              </div>
                <div class="list">
                    <img :src="abilityList[isCurrentAbility]" alt="">
                    <div class="btn">
                        <div class="pre" @click="activeClick('pre')"></div>
                        <div class="next" @click="activeClick('next')"></div>
                    </div>
                </div>
              </div>
          </div>

          <!-- 合作保障 -->
          <div class="cooperation">
            <div class="wrapper">
              <div class="title">合作保障</div>
              <div class="bg-scheme-svg">
                <div style="width:1427px; margin:0 auto;">
                  <svg width="1427" height="106" viewBox="0 0 1427 106" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient id="text-stroke-gradient-3" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stop-color="#000000"/>
                        <stop offset="100%" stop-color="rgba(0,0,0,0)"/>
                      </linearGradient>
                    </defs>
                    <text
                      x="50%"
                      y="50%"
                      text-anchor="middle"
                      font-size="76"
                      font-family="PingFang SC, PingFang SC-400"
                      font-weight="600"
                      stroke="url(#text-stroke-gradient-3)"
                      stroke-width="2"
                      fill="transparent"
                      opacity="0.1"
                      dominant-baseline="middle"
                        style="font-size:76px !important;"
                    >
                      COOPERATION GUARANTEE
                    </text>
                  </svg>
                </div>
              </div>
              <div class="list">
                <img src="@img/software/pic_rjyf_hzbz.png" alt="">
              </div>
            </div>
          </div>

          <!-- 云百软件优势 -->
          <div class="advantage">
            <div class="wrapper">
                <div class="title">云百软件优势</div>
                <div class="bg-scheme-svg">
                  <div style="width:1427px; margin:0 auto;">
                    <svg width="1427" height="106" viewBox="0 0 1427 106" xmlns="http://www.w3.org/2000/svg">
                      <defs>
                        <linearGradient id="text-stroke-gradient-4" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stop-color="#FFFFFF"/>
                          <stop offset="100%" stop-color="rgba(255,255,255,0)"/>
                        </linearGradient>
                      </defs>
                      <text
                        x="50%"
                        y="50%"
                        text-anchor="middle"
                        font-size="76"
                        font-family="PingFang SC, PingFang SC-400"
                        font-weight="600"
                        stroke="url(#text-stroke-gradient-4)"
                        stroke-width="2"
                        fill="transparent"
                        opacity="0.2"
                        dominant-baseline="middle"
                          style="font-size:76px !important;"
                      >
                        SOFTWARE ADVANTAGES
                      </text>
                    </svg>
                  </div>
                </div>
                <div class="list">
                    <div class="point" :class="isCurrentPoint == index ? 'current': ''" v-for="(item, index) in advantageList" :key="item.name" @click="clickPoint(index)">
                    {{ item.name }}
                    </div>
                </div>
                <div class="page">
                    <div class="pic" v-for="pic in advantageList[isCurrentPoint].list" :key="pic.name">
                        <div class="img"><img :src="pic.img" alt=""></div>
                        <div class="name">{{ pic.name }}</div>
                        <div class="desc">{{ pic.desc }}</div>
                    </div>
                </div> 
            </div>
          </div>

          <!-- 项目案例 -->
          <div class="case">
            <div class="wrapper">
              <div class="title">项目案例</div>
              <div class="bg-scheme-svg">
                <div style="width:1427px; margin:0 auto;">
                  <svg width="1427" height="106" viewBox="0 0 1427 106" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient id="text-stroke-gradient-5" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stop-color="#000000"/>
                        <stop offset="100%" stop-color="rgba(0,0,0,0)"/>
                      </linearGradient>
                    </defs>
                    <text
                      x="50%"
                      y="50%"
                      text-anchor="middle"
                      font-size="76"
                      font-family="PingFang SC, PingFang SC-400"
                      font-weight="600"
                      stroke="url(#text-stroke-gradient-5)"
                      stroke-width="2"
                      fill="transparent"
                      opacity="0.1"
                      dominant-baseline="middle"
                        style="font-size:76px !important;"
                    >
                      PROJECT CASE
                    </text>
                  </svg>
                </div>
              </div>
              <div class="list">
                <div class="item" v-for="item in caseList" :key="item.name">
                    <div class="img"><img :src="item.img" alt=""></div>
                    <div class="box" @click="openDialog(item)">
                        <div class="name">{{item.name}}</div>
                        <div class="foot">
                            <div class="tag">{{item.tag}}</div>
                            <div class="detail">
                                <div class="check">查看</div>
                                <img src="@img/software/Frame 381.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <el-footer style="background:#f4f6f9;">
        <v-footer></v-footer>
      </el-footer>
    </el-container>
    <plan-dialog
      :isShow="isShow"
      v-if="isShow"
      @closeTop="closeTop"
    ></plan-dialog>
    <div class="dialog" v-if="showDialog">
        <div class="content">
            <div class="head">
                <div class="left">
                    <div class="name">{{dialogCase.name}}</div>
                </div>
                <div class="right" @click="showDialog = false, currentCasePic = 0">
                    <img src="@img/software/Frame 674.png" alt="">
                </div>
            </div>
            <div class="tag"><span>{{dialogCase.tag}}</span></div>
            <div class="box">
                <div class="topic">
                    <div class="left">
                        <div class="icon"></div>
                        <div class="label">建设内容</div>
                    </div>
                    <div class="right">
                        CONSTRUCTION CONTENT
                    </div>
                </div>
                <div class="con">
                    {{dialogCase.content}}
                </div>
            </div>
            <div class="box">
                <div class="topic">
                    <div class="left">
                        <div class="icon"></div>
                        <div class="label">价值体现</div>
                    </div>
                    <div class="right">
                        VALUE MANIFESTATION
                    </div>
                </div>
                <div class="con">
                    {{dialogCase.price}}
                </div>
            </div>
            <div class="box">
                <div class="topic">
                    <div class="left">
                        <div class="icon"></div>
                        <div class="label">案例图片<span class="picNum" >({{currentCasePic+1}}/{{dialogCase.casePic.length}})</span></div>
                    </div>
                    <div class="right">
                        CONSTRUCTION CONTENT
                    </div>
                </div>
                <div class="conPic">
                    <div class="pre" @click="digPicPre"></div>
                    <div class="pic"><img :src="dialogCase.casePic[currentCasePic].img" alt=""></div>
                    <div class="next" @click="digPicNext"></div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import vHead from "../components/head.vue";
import vFooter from "../components/softwareFooter.vue";
import planDialog from "@components/planDialog.vue";
import softwareImg from "./softwareImg.vue";
export default {
  name: "software",
  metaInfo: {
    title: "软件研发",
    meta: [
      {
        name: "keyWords",
        content: "物联网，网关，自动化，软硬件开发，车联网，监控，智慧码头",
      },
    ],
  },
  components: {
    vHead,
    vFooter,
    planDialog,
    softwareImg
  },
  data() {
    return {
      isShow: false,
      showBigPic: false,
      bannerData: [
        {
          title: "专业研发・定制无忧",
          titleWrap: false,
          content:
            "我们拥有技术力量雄厚、项目经验丰富的专家研发团队，提供专业、完整的软件定制方案。拥有多个行业和领域的成功案例，方案、产品具备出色的性能、安全性和可靠性，满足企业的需求和期望。",
          button: "获取专属方案",
          banner: "software_bg",
        },
      ],
      softwareList1: [
        {
            name: '软件咨询',
            en: 'SOFTWARE CONSULTATION',
            info: '基于行业经验和前沿技术为客户提供全方位的软件咨询服务。',
            logo: require('@img/software/icon_rjyf_rjfw_zx.png'),
            img: require('@img/software/pic_rjyf_rjfw_zx_nor.png'),
            expandImg: require('@img/software/pic_rjyf_rjfw_zx_pre.png'),
        },
        {
            name: '定制开发',
            en: 'CUSTOMIZED DEVELOPMENT',
            info: '聚合优质行业资源，基于自身行业经验，为客户提供高并发、高可靠、高稳定、高品质的定制开发服务。',
            logo: require('@img/software/icon_rjyf_rjfw_kf.png'),
            img: require('@img/software/pic_rjyf_rjfw_kf_nor.png'),
            expandImg: require('@img/software/pic_rjyf_rjfw_kf_pre.png'),
        },
        {
            name: '信息安全',
            en: 'INFORMATION SECURITY',
            info: '构建安全防护体系，防御网络攻击，保护企业数据资产，确保业务连续性和企业声誉。',
            logo: require('@img/software/icon_rjyf_rjfw_aq.png'),
            img: require('@img/software/pic_rjyf_rjfw_aq_nor.png'),
            expandImg: require('@img/software/pic_rjyf_rjfw_aq_pre.png'),
        },
      ],
      softwareList2: [
        {
            name: '数据治理',
            en: 'DATA GOVERNANCE',
            info: '确保数据的质量、完整性和一致性，以最大限度地提高数据的可靠性和可用性。',
            logo: require('@img/software/icon_rjyf_rjfw_zl.png'),
            img: require('@img/software/pic_rjyf_rjfw_zl_nor.png'),
            expandImg: require('@img/software/pic_rjyf_rjfw_zl_pre.png'),
        },
        {
            name: '运营运维',
            en: 'OPERATION AND MAINTENANCE',
            info: '专业的运营运维团队，为客户数智化升级提供助力。',
            logo: require('@img/software/icon_rjyf_rjfw_yw.png'),
            img: require('@img/software/pic_rjyf_rjfw_yw_nor.png'),
            expandImg: require('@img/software/pic_rjyf_rjfw_yw_pre.png'),
        },
        {
            name: '数字化转型',
            en: 'DIGITAL TRANSFORMATION',
            info: '帮助企业提高效率、创新服务、扩展市场。利用大数据分析、人工智能、让企业保持竞争力。',
            logo: require('@img/software/icon_rjyf_rjfw_zx (1).png'),
            img: require('@img/software/pic_rjyf_rjfw_zx_nor (1).png'),
            expandImg: require('@img/software/pic_rjyf_rjfw_zx_pre (1).png'),
        },
      ],
      softwareListActive1: 0,
      softwareListActive2: 2,
      isCurrentAbility: 0,
      abilityList: [
        require('@img/software/pic_rjyf_cxnl_jscx.png'),
        require('@img/software/pic_rjyf_cxnl_ydjr.png')
      ],
      advantageList: [
        {
          name: '荣誉资质',
          list: [
            {
              img: require('@img/software/pic_rjyf_rjys_ryzz@2x.png'),
              name: '专精特新',
              desc: '广东省专精特新中小企业'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_rybs@2x.png'),
              name: '博士工作站',
              desc: '广东省博士工作站'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_rycmmi@2x.png'),
              name: 'CMMI-5级',
              desc: 'CMMI集成认证5级'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_ryiso@2x.png'),
              name: 'ISO认证',
              desc: 'ISO9001/ISO27000/ISO27001认证'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_ry100@2x.png'),
              name: '近100项',
              desc: '其他近百项荣誉资质'
            },

          ]
        },
        {
          name: '团队优势',
          list: [
            {
              img: require('@img/software/pic_rjyf_rjys_ys200@2x.png'),
              name: '200+',
              desc: '团队成员200+'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_ys80@2x.png'),
              name: '80%+',
              desc: '技术人员占比超80%'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_ys30@2x.png'),
              name: '30%+',
              desc: '5年及以上的经验人员超30%'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_ysbz@2x.png'),
              name: '编制优承接强',
              desc: '编制齐全，承接能力高，能同时进行多个大型项目'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_ysmx@2x.png'),
              name: '名校名企',
              desc: '核心团队成员均来自海内外名校，曾供职于三大运营商、华为、电网、各大高校、科研机构等'
            },
          ]
        },
        {
          name: '行业覆盖',
          list: [
           {
              img: require('@img/software/pic_rjyf_rjys_hy1000@2x.png'),
              name: '1000+',
              desc: '1000+软件方案案例'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_hy30@2x.png'),
              name: '30+',
              desc: '30+行业深度覆盖'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_hy300@2x.png'),
              name: '300+',
              desc: '服务客户300+'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_hy130@2x.png'),
              name: '130+',
              desc: '辐射国家130+'
            },
          ]
        },
        {
          name: '信息安全保障',
          list: [
            {
              img: require('@img/software/pic_rjyf_rjys_bzzj@2x.png'),
              name: '专家阵容',
              desc: '中科院国家级百人计划引才专家任首席信息安全专家'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_bzgx@2x.png'),
              name: '工信部项目',
              desc: '承接工信部整车信息安全项目(196、202项目)'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_bztc@2x.png'),
              name: 'TC260',
              desc: '全国信息安全标准化技术委员会成员单位'
            },
            {
              img: require('@img/software/pic_rjyf_rjys_bzcrcc@2x.png'),
              name: 'CCRC-3级',
              desc: 'CCRC信息安全服务资质认证3级'
            },
          ]
        }
      ],
      isCurrentPoint: 0,
      intervalId: null, 
      caseList: [
        {
            img: require('@img/software/pic_rjyf_xmal01.png'),
            name: 'eSIM IOT物联网系统项目',
            tag: 'IOT',
            content: 'eSIM IOT物联网系统基于最新颁发的GSMA协议，针对物联网场景，对物联设备的eSIM卡以及profile码号资源进行管理、关联、空中写号等操作，通过平台实现对物联设备的联网状态进行运维监控，对物联设备的跨境运行需求提供灵活分配资源、切换资源的服务。',
            price: '支持对接境内境外的运营商资源，针对物联网场景，对物联设备的eSIM卡信息以及运营商联网码号资源的空写进行运维监控。',
            casePic: [
                {
                    img: require('@img/software/esim1 (1).jpg')
                },
                {
                    img: require('@img/software/esim1 (2).jpg')
                }
            ]
        },
        {
            img: require('@img/software/pic_rjyf_xmal02.png'),
            name: '中国移动5G车联网运营平台',
            tag: '车联网',
            content: '满足比亚迪3个国内品牌对物联网卡的全生命周期管理需求，主要功能包括：卡资源管理、卡生命周期管理、资费套餐管理、车机远程控制、车主信息管理等。目前已对接云百物联网卡平台（移动卡）和联通CMP平台（联通卡）。',
            price: '专门为比亚迪车品牌仰望、方程豹、T45商用车提供车机用物联网卡管理服务。对接云百4、5G物联网卡平台，为客户打造完整的卡应用和卡管理能力体系。',
            casePic: [
                {
                    img: require('@img/software/5g (1).png')
                },
                {
                    img: require('@img/software/5g (2).png')
                },
                {
                    img: require('@img/software/5g (3).png')
                }
            ]
        },
        {
            img: require('@img/software/pic_rjyf_xmal03.png'),
            name: '中核海得威三维可视化数据中台',
            tag: '智慧园区',
            content: '提供统一认证、智慧办公、餐厅订餐、访客平台、安防监控、消防监测、能耗监测、工控监测等模块完整园区管理解决方案，实时收集设备数据，并通过能效分析和园区各区域的使用监测，结合能源设备调控和实时告警，同时系统提供数据大屏和移动化监视能力，园区协同管理更加直观高效。',
            price: '为客户集成各类能源设备的运行信息收集及管理，并通过大屏数据可视化的方式，实现能源设备的集中呈现、集中检测、集中管理。提供设备维护计划、自动化管理规则、能源数据分析（报表）等能力，打造节约高效的能源管理体系。',
            casePic: [
                {
                    img: require('@img/software/hdw1.jpg')
                },
                {
                    img: require('@img/software/hdw2.png')
                },
                {
                    img: require('@img/software/hdw3.jpg')
                },
                {
                    img: require('@img/software/hdw4.jpg')
                },
                {
                    img: require('@img/software/hdw5.jpg')
                },
                {
                    img: require('@img/software/hdw6.jpg')
                },
                {
                    img: require('@img/software/hdw7.png')
                },
                {
                    img: require('@img/software/hdw8.png')
                },
                {
                    img: require('@img/software/hdw9.png')
                },
                {
                    img: require('@img/software/hdw10.jpg')
                },
                {
                    img: require('@img/software/hdw11.png')
                },
                {
                    img: require('@img/software/hdw12.jpg')
                },
                {
                    img: require('@img/software/hdw13.png')
                },
                {
                    img: require('@img/software/hdw14.jpg')
                }
            ]
        },
        {
            img: require('@img/software/pic_rjyf_xmal04.png'),
            name: '智慧物业管理系统',
            tag: '智慧物业',
            content: '智慧物业管理系统主要是围绕物业日常运管为基础，通过数据模块结合不同场景的用水用电的计量设备数据采集监测、专为物业用户业主提供水电表集抄、房源管理、设备管理、运维管理、水电预付费、后付费等提供解决方案，为物业用户业主提供数字化服务，为物业管理数字化赋能。',
            price: '围绕物业日常运营管理，通过对房间、水电表设备、账单费用管理等模块，为物业管理方提供全方位的数据维护以及信息监管服务。',
            casePic: [
                {
                    img: require('@img/software/park1 (1).jpg')
                },
                {
                    img: require('@img/software/park1 (2).jpg')
                },
                {
                    img: require('@img/software/park1 (3).jpg')
                }
            ]
        },
        {
            img: require('@img/software/pic_rjyf_xmal05.png'),
            name: 'AI智能标注平台',
            tag: 'AI',
            content: '通过AI数据标注平台，支持掌控数据标注的整个流程，提升数据标注的质量和效率，同时能积累和保留高价值的标注数据资源，其主要功能包括标注任务创建与管理、标注工具的集成、标注任务审核与质量控制、通过培训与学习算法实现自动化辅助标注、统计与报表功能等',
            price: '为无人驾驶领域下，通过激光雷达扫描采集到汽车周围环境的3D点云数据，进行目标物体的标注，以便机器学习算法能够理解和学习这些数据的特征和模式，实现智能标注。',
            casePic: [
                {
                    img: require('@img/software/ai1.jpg')
                }
            ]
        },
        {
            img: require('@img/software/pic_rjyf_xmal06.png'),
            name: '空气能设备监控平台',
            tag: 'IOT',
            content: '空气能监控平台是一套集远程操控、实时数据监测、数据分析、客户管理、经销商管理、SIM卡管理、设备管理和系统管理于一体的综合性系统。',
            price: '为空气能设备独立配置开发的一套平台，对空气能设备的全生命周期进行管理，支持对空气能的运行情况进行分析、OTA等操作，同时采用厂家、经销商、终端客户的维度，进行设备数据隔离，控制用户数据范围。',
            casePic: [
                {
                    img: require('@img/software/air1 (1).jpg')
                },
                {
                    img: require('@img/software/air1 (2).jpg')
                },
                {
                    img: require('@img/software/air1 (3).jpg')
                }
            ]
        },
      ],
      showDialog: false,
      dialogCase: {},
      currentCasePic: 0
    };
  },
  computed: {
    platFormHeadCurrent() {
        return this.platFormDetails[this.platFormActive].topImg[this.head_ative];
    },
    currentCaseImg() {
        return this.caseMenuList[this.currentCase].img;
    }
  },
  created() {},
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  updated() {},
  methods: {
    digPicPre(){
        if(this.currentCasePic == 0) return;
        this.currentCasePic--;
    },
    digPicNext(){
        if(this.currentCasePic == this.dialogCase.casePic.length-1) return;
        this.currentCasePic++;
    },
    activeClick(type) {
        if(type == 'pre') {
            this.isCurrentAbility = 0;
        }else if(type == 'next') {
            this.isCurrentAbility = 1;
        }
    },
    service1Enter(index) {
        this.softwareListActive1 = index;
    },
    service2Enter(index) {
        this.softwareListActive2 = index;
    },
    openDialog(item) {
        this.showDialog = true;
        this.dialogCase = item;
    },
    clickPoint(index){
        this.stopAutoPlay();
        this.isCurrentPoint = index;
        this.startAutoPlay();
    },
    startAutoPlay() {
      this.intervalId = setInterval(this.next, 4000);
    },
    next() {
      this.isCurrentPoint = (this.isCurrentPoint + 1) % this.advantageList.length;
    },
    stopAutoPlay() {
      clearInterval(this.intervalId);
    },
    closeTop() {
      this.isShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "~@/style/base.scss";
::v-deep .el-main{
    overflow: hidden;
}
.title {
    margin-top: 120px;
    font-size: 40px;
    font-weight: bold;
    height: 48px;
    line-height: 48px;
    color: #333;
    font-family: "PingFang SC", "PingFang SC-400";
    text-align: center;
    &::after {
      content: "";
      display: block;
      width: 80px;
      height: 4px;
      background: linear-gradient(90deg,#0c9aff, #0c45ff 100%);;
      margin: 10px auto 0;
    }
  }
.bg-scheme{
    width: 1427px;
    height: 106px;
    font-size: 76px;
    font-family: "PingFang SC", "PingFang SC-400";
    font-weight: 600;
    text-align: center;
    margin: 0 auto;
    color: transparent;
    // -webkit-text-fill-color: transparent; // 只要描边色，不要填充色
    -webkit-text-stroke-width: 2px; //描边宽度
    /* -webkit-text-stroke-color: #fff; //描边颜色白色 */
    border-image: linear-gradient(180deg, #000000 0%, rgba(0,0,0,0.00) 100%) 3 3;
    background: none;
    -webkit-background-clip: text; //背景剪裁到文字;
    background-clip: text; //背景剪裁到文字;
    opacity: 0.3;
}
//软件服务
.service{
    padding-bottom: 120px;
    .list{
        display: flex;
        width: 1400px;
        gap: 24px;
        margin: 0 auto;
        margin-bottom: 24px;
        .item{
            .pic{
                width: 332px;
                height: 250px;
                img{
                    width: 332px;
                    object-fit: cover;
                    border-radius: 16px 16px 0px 0px;
                }
            }
            .expandPic{
                width: 688px;
                height: 250px;
                img{
                    width: 688px;
                    border-radius: 16px 16px 0px 0px;
                }
            }
            .box{
                position: relative;
                width: 267px;
                height: 166px;
                background: #ffffff;
                border: 1px solid #e5e7eb;
                border-radius: 16px;
                margin-top: -20px;
                padding: 60px 32px 32px 32px;
                z-index: 10;
                .logo{
                    position: absolute;
                    top: -63px;
                    width: 120px;
                    height: 120px;
                    img{
                        width: 120px;
                    }
                }
                .en{
                    font-size: 12px;
                    margin-top: 37px;
                    font-family: "PingFang SC", "PingFang SC-400";
                    font-weight: 400;
                    text-align: left;
                    color: #999999;
                }
                .label{
                    margin-top: 4px;
                    font-size: 24px;
                    font-family: "PingFang SC", "PingFang SC-400";
                    font-weight: 600;
                    text-align: left;
                    color: #333333;
                }
                .info{
                    margin-top: 16px;
                    font-size: 14px;
                    font-family: "PingFang SC", "PingFang SC-400";
                    font-weight: 400;
                    text-align: left;
                    color: #666666;
                }
            }
            .expandBox{
                position: relative;
                width: 624px;
                height: 166px;
                background: #ffffff;
                border: 1px solid #0c9aff;
                // border-image: linear-gradient(109deg, #0c9aff 0%, #0063e6 100%) 1 1;
                border-radius: 16px;
                margin-top: -20px;
                z-index: 10;
                .logo{
                    position: absolute;
                    top: -63px;
                    width: 120px;
                    height: 120px;
                    img{
                        width: 120px;
                    }
                }
                .label{
                    margin-top: 4px;
                    font-size: 24px;
                    font-family: "PingFang SC", "PingFang SC-400";
                    font-weight: 600;
                    text-align: left;
                    color: #0c45ff;
                }
                .info{
                    margin-top: 16px;
                    font-size: 14px;
                    font-family: "PingFang SC", "PingFang SC-400";
                    font-weight: 400;
                    text-align: left;
                    color: #666666;
                }
            }
        }
    }
}
//创新能力
.ability{
    width: 100%;
    // margin: 0 auto;
    padding: 60px 0 100px 0;
    background: #fafafa;
    .list{
        margin: 0 auto;
        margin-top: -30px;
        width: 1400px;
        img{
            width: 1400px;
        }
        .btn{
            width: 1400px;
            display: flex;
            justify-content: center;
            margin: 0 auto;
            margin-top: -70px;
            .pre{
                width: 40px;
                    height: 40px;
                    margin-right: 20px;
                    background: url('../../public/img/software/icon_rjyf_cxnl_left_nor.png');
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background: url('../../public/img/software/icon_rjyf_cxnl_left_pre.png'); 
                        background-size: cover;
                        background-position: center;
                        background-repeat: no-repeat;
                    }
            }
            .next{
                width: 40px;
                    height: 40px;
                    background: url('../../public/img/software/icon_rjyf_cxnl_right_nor.png');
                    background-size: 100% 100%;

                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background: url('../../public/img/software/icon_rjyf_cxnl_right_pre.png'); 
                        background-size: cover;
                        background-position: center;
                        background-repeat: no-repeat;
                    }
            }
        }
    }
}
// 合作保障
.cooperation{
    width: 100%;
    padding: 60px 0;
    .list{
        margin: 0 auto;
        margin-top: -30px;
        width: 1400px;
        img{
            width: 1400px;
            object-fit: cover;
        }
    }
}
//软件优势
.advantage{
    .bg-scheme{
        width: 1427px;
        height: 106px;
        font-size: 76px;
        font-family: "PingFang SC", "PingFang SC-400";
        font-weight: 600;
        text-align: center;
        margin: 0 auto;
        color: transparent;
        -webkit-text-fill-color: transparent; // 只要描边色，不要填充色
        -webkit-text-stroke-width: 2px; //描边宽度
        /* -webkit-text-stroke-color: white; //描边颜色白色 */
        border-image: linear-gradient(180deg, #000000 0%, rgba(0,0,0,0.00) 100%) 3 3;
        background: none;
        -webkit-background-clip: text; //背景剪裁到文字;
        background-clip: text; //背景剪裁到文字;
        opacity: 0.1;
    }
    .wrapper{
        width: 100%;
        height: 724px;
        background: url('../../public/img/software/pic_rjyf_rjys_bg.png');
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        // padding-top: 120px;
        .title {
            
            font-size: 40px;
            font-weight: 400;
            height: 48px;
            line-height: 48px;
            color: #FFFFFF;
            font-family: "PingFang SC", "PingFang SC-400";
            text-align: center;
            // margin-top: 120px;
            padding-top: 120px;
            &::after {
            content: "";
            display: block;
            width: 80px;
            height: 4px;
            background: #fff;
            margin: 10px auto 0;
            }
        }
        .list{
            width: 1400px;
            display: flex;
            justify-content: center;
            margin: 0 auto;
            margin-top: -50px;
            gap: 16px;
            .point{
                text-align: center;
                padding: 11px 32px 11px 32px;
                font-size: 16px;
                color: #FFFFFF;
                border: 1px solid #ffffff;
                border-radius: 4px;
                cursor: pointer;
                z-index: 10;
            }
            .current{
                text-align: center;
                padding: 11px 32px 11px 32px;
                color: #0C45FF;
                font-size: 16px;
                background: #fff;
                border-radius: 4px;
            }
        }
        .page{
            margin-top: 61px;
            width: 100%;
            display: flex;
            justify-content: center;
            .pic{
                padding: 0 30px 0 30px;
                .img{
                    width: 141px;
                    height: 140px;
                    margin: 0 auto;
                    object-fit: cover;
                    img{
                        width: 141px;
                    object-fit: cover;

                    }
                }
                .name{
                    margin-top: 24px;
                    font-size: 34px;
                    font-family: "PingFang SC", "PingFang SC-400";
                    font-weight: 400;
                    text-align: center;
                    color: #ffffff;
                }
                .desc{
                    width: 220px;
                    margin-top: 6px;
                    font-size: 14px;
                    font-family: "PingFang SC", "PingFang SC-400";
                    font-weight: 400;
                    text-align: center;
                    color: #ffffff;
                }
            }
        }
    }
}
//项目案例
.case{
    .wrapper{
        width: 100%;
        margin: 0 auto;
        padding: 0 0 120px 0;
        .list{
            width: 1400px;;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin: 0 auto;
            margin-top: -40px;
            gap: 25px;
            .item{
                position: relative;
                // margin-bottom: 24px;
                width: 450px;
                height: 334px;
                .img{
                    
                    width: 450px;
                    height: 334px;
                    img{
                        width: 450px;
                    }
                }
                .box{
                    position: absolute;
                    bottom: 24px;
                    left: 24px;
                    right: 24px;
                    width: 354px;
                    height: 78px;
                    padding: 24px 24px 21px 24px;
                    background: linear-gradient(180deg,rgba(255,255,255,0.80) 0%, #ffffff 100%);
                    border-image: linear-gradient(180deg, #ffffff, rgba(255,255,255,0.00) 100%) 1 1;
                    border-radius: 16px;
                    box-shadow: 0px 4px 16px 0px #ffffff inset; 
                    cursor: pointer;
                    z-index: 10;
                    .name{
                        color: #333333;
                        font-size: 18px;
                        font-weight: 400;
                        text-align: left;
                        font-family: "PingFang SC", "PingFang SC-400";
                    }
                    .foot{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-top: 29px;
                        .tag{
                            padding: 2px 8px 2px 8px;
                            background: rgba(12,69,255,0.08);
                            border-radius: 4px;
                            font-size: 14px;
                            font-family: "PingFang SC", "PingFang SC-400";
                            font-weight: 400;
                            text-align: left;
                            color: #0c45ff;
                        }
                        .detail{
                            display: flex;
                            align-items: center;
                            .check{
                                font-size: 14px;
                                font-family: "PingFang SC", "PingFang SC-400";
                                font-weight: 400;
                                text-align: right;
                                color: #0c45ff;
                                line-height: 24px;
                                margin-right: 3.5px;
                            }
                            img{
                                width: 21px;
                                height: 16px;
                            }
                        }
                        
                    }
                }
            }
        }
    }
}
//弹窗
.dialog{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.3);
    z-index: 99;
    .content{
        position: absolute;
        top: 50%;
        transform: translate(50%, -50%);
        width: 929px;
        height: 772px;
        background: #ffffff;
        border-radius: 20px;
        padding: 24px;
        .head{
            display: flex;
            justify-content: space-between;
            .left{
                .name{
                    font-size: 24px;
                    font-family: "PingFang SC", "PingFang SC-400";
                    font-weight: 600;
                    text-align: left;
                    color: #333333;
                }
                
            }
            .right{
                cursor: pointer;
            }
        }
        .tag{
            display: flex;
            span{
                background: rgba(12,69,255,0.08);
            border-radius: 4px;
            padding: 4px 8px 4px 8px;
            font-size: 14px;
            font-family: "PingFang SC", "PingFang SC-400";
            font-weight: 400;
            text-align: left;
            color: #0c45ff;
            }
        }
        .box{
            margin-top: 24px;
            background: #fafafa;
            border-radius: 20px;
            padding: 24px;
            
            .topic{
                display: flex;
                justify-content: space-between;
            }   
            .left{
                display: flex;
                align-items: center;
                .icon{
                    width: 4px;
                    height: 14px;
                    background: linear-gradient(270deg,#0c45ff 0%, #0c45ff);
                    border-radius: 2px;
                }
                .label{
                    margin-left: 8px;
                    font-size: 16px;
                    font-family: "PingFang SC", "PingFang SC-400";
                    font-weight: 600;
                    text-align: left;
                    color: #333333;
                    .picNum{
                        opacity: 0.6;
                    }
                }
            }
            .right{
                font-size: 12px;
                font-family: "PingFang SC", "PingFang SC-400";
                font-weight: 400;
                text-align: right;
                color: #999999;
            }
            .con{
                margin-top: 16px;
                text-align: left;
                font-size: 12px;
                font-family: "PingFang SC", "PingFang SC-400";
                font-weight: 400;
                text-align: left;
                color: #333333;
                line-height: 20px;  
            }
            .conPic{
                margin-top: 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .pre{
                    width: 40px;
                    height: 40px;
                    background: url('../../public/img/intelligentize/icon_szh_zhptyy_lb_left_nor@2x.png');
                    margin-right: 50px;
                    background-size: 100% 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                    
                    cursor: pointer;
                    &:hover{
                        background: url('../../public/img/intelligentize/icon_szh_zhptyy_lb_left_pre@2x.png'); 
                        background-size: cover;
                        background-position: center;
                        background-repeat: no-repeat;
                    }
                }
                .pic{
                    width: 510px;
                    // height: 264px;
                    img{
                        width: 510px;
                    }
                }
                .next{
                    width: 40px;
                    height: 40px;
                    margin-left: 50px; 
                    background: url('../../public/img/intelligentize/icon_szh_zhptyy_lb_right_nor@2x.png');
                    background-size: 100% 100%;

                    background-position: center;
                    background-repeat: no-repeat;
                    cursor: pointer;
                    &:hover{
                        background: url('../../public/img/intelligentize/icon_szh_zhptyy_lb_right_pre@2x.png'); 
                        background-size: cover;
                        background-position: center;
                        background-repeat: no-repeat;
                    }
                }
            }
        }
    }
}
.bg-scheme-svg {
  width: 100%;
  height: 106px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  overflow: visible;
}
</style>
